import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { CanvasType, SizeType } from 'types/Canvas';
import { RatioFormatType } from 'types/RatioFormat';
import Konva from 'konva';

const defaultState: CanvasType = {
  size: {
    width: 0,
    height: 0
  },
  isSeeking: false,
  ratioChanged: null,
  textLayerVisible: true,
  konvaLayer: null,
};
export const setCanvasSize = createActionCreator(
  'PREVIEW/SET_CANVAS_SIZE',
  resolve => (width: number, height: number) => resolve({ width, height })
);
export const setSeeking = createActionCreator(
  'PREVIEW/SET_SEEKING',
  resolve => (isSeeking: CanvasType['isSeeking']) => resolve(isSeeking)
);
export const setRatioChanged = createActionCreator(
  'PREVIEW/RATIO_CHANGED',
  resolve => (state: null | RatioFormatType) => resolve(state)
);
export const setTextLayerVisible = createActionCreator(
  'PREVIEW/TEXT_LAYER_VISIBLE',
  resolve => (state: boolean) => resolve(state)
);
export const setKonvaLayer = createActionCreator('PREVIEW/SET_KONVA_LAYER', resolve => (layer: Konva.Layer) => resolve(layer));

export const canvas = createReducer(defaultState, handle => [
  handle(setRatioChanged, (state, { payload }) => ({ ...state, ratioChanged: payload })),
  handle(setCanvasSize, (state, { payload }) => ({ ...state, size: payload })),
  handle(setSeeking, (state, { payload }) => ({ ...state, isSeeking: payload })),
  handle(setTextLayerVisible, (state, { payload }) => ({ ...state, textLayerVisible: payload })),
  handle(setKonvaLayer, (state, { payload }) => ({ ...state, konvaLayer: payload }))
]);

export const getCanvasSize = (state: AppState): SizeType => state.canvas.size;
export const isSeeking = (state: AppState): boolean => state.canvas.isSeeking;
export const getRatioChanged = (state: AppState): CanvasType['ratioChanged'] =>
  state.canvas.ratioChanged;
export const isTextLayerVisible = (state: AppState): boolean => state.canvas.textLayerVisible;
export const getKonvaLayer = (state: AppState): Konva.Layer => state.canvas.konvaLayer;
